import { Controller } from '@hotwired/stimulus';

import Checkout from '@/modules/checkout';
import ModuleLoader from '@/modules/module_loader';
import Product from '@/modules/product';

export default class extends Controller {
  connect() {
    new Product().create();
    new Checkout(ModuleLoader.getOptions()).create();
  }
}
